import { render, staticRenderFns } from "./ReadMessage.vue?vue&type=template&id=4190ec20"
import script from "./ReadMessage.vue?vue&type=script&lang=js"
export * from "./ReadMessage.vue?vue&type=script&lang=js"
import style0 from "./ReadMessage.vue?vue&type=style&index=0&id=4190ec20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports